import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { IRealtimeService } from '../interfaces/realtime-service.interface';
import { RSocketService } from '../rsocket-service/r-socket.service';
import { SignalRService } from '../signalr-service/signalr.service';

@Injectable({
  providedIn: 'root'
})
export class RealtimeServiceFactory {
  private rSocketService = inject(RSocketService);
  private signalRService = inject(SignalRService);
  private currentService?: IRealtimeService;
  private fallbackAttempted = false;

  createService(): IRealtimeService {
    try {
      if (environment.useSignalR) {
        console.log('Using SignalR service for real-time communication');
        this.currentService = this.signalRService;
        return this.signalRService;
      } else {
        console.log('Using RSocket/STOMP service for real-time communication');
        this.currentService = this.rSocketService;
        return this.rSocketService;
      }
    } catch (error) {
      console.error('Error creating realtime service:', error);
      return this.getFallbackService();
    }
  }

  createServiceWithFallback(): IRealtimeService {
    const primaryService = this.createService();

    setTimeout(() => {
      if (!primaryService.isConnected() && !this.fallbackAttempted) {
        console.warn('Primary service failed to connect, attempting fallback');
        this.fallbackAttempted = true;
        this.getFallbackService();
      }
    }, 5000);

    return primaryService;
  }

  private getFallbackService(): IRealtimeService {
    console.log('Switching to fallback service');
    
    if (environment.useSignalR) {
      console.log('Falling back to RSocket/STOMP service');
      this.currentService = this.rSocketService;
      return this.rSocketService;
    } else {
      console.log('Falling back to SignalR service');
      this.currentService = this.signalRService;
      return this.signalRService;
    }
  }

  getCurrentService(): IRealtimeService | undefined {
    return this.currentService;
  }

  getCurrentServiceType(): string {
    if (!this.currentService) return 'None';
    
    if (this.currentService === this.signalRService) {
      return 'SignalR';
    } else if (this.currentService === this.rSocketService) {
      return 'RSocket/STOMP';
    }
    
    return 'Unknown';
  }

  resetFallbackState(): void {
    this.fallbackAttempted = false;
  }
}